<template>
    <div class="modal_content" v-pml-block="isLoading">
        <router-view></router-view>
        <div class="row m_bottom_15">
            <div class="col-sm-8 col-md-6">
                <div class="d_table">
                    <div class="d_t_cell p-r-10">
                        <img src="/static/images/avatar-company.png" alt="" class="img-responsive img-circle max_h_40">
                    </div>
                    <div class="d_t_cell">
                        <h4 class="header-title">{{ record.fancy_name }} <small class="show m-t-5">({{ record.name }})</small></h4>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 m_bottom_15">
                <span class="btn btn-warning" v-pml-tooltip="$t('refresh')" @click="fetchRecord"><i class="fa fa-refresh"></i></span>
                <button class="btn btn-default" @click.prevent="isAdding = true">
                    <span class="btn-label">
                        <i class="fa fa-plus-circle"></i>
                    </span>
                    {{ $t('product') }}
                </button>
                <router-link :to="{ name: 'suppliers.index' }" class="btn btn-white btn_na">{{ $t('cancel') }}</router-link>
                <span class="pull-right m-t-10">{{ $t('data_grid_entries_showing', [list.length]) }}</span>
            </div>
            <div class="col-md-6 m_bottom_15">
                <input type="text" class="form-control" :placeholder="`${$t('search')}...`" v-model="listConfig.filter">
            </div>
        </div>
        <div>
            <table class="table table-striped custom_nth table-bordered m-0 table_border_out">
                <thead>
                    <tr>
                        <th class="th_sort min_w_150" @click="setOrder('product.name')" :class="isOrderedColumn('product.name')">{{ $t('product') }}</th>
                        <th class="th_sort t_center w_155" @click="setOrder('price')" :class="isOrderedColumn('price')">{{ $t('price') }}</th>
                        <th class="t_center w_125">{{ $t('kickback') }}</th>
                        <th class="t_center w_125">{{ $t('discount_limit') }}</th>
                        <th class="t_center w_190">{{ $t('unit') }}</th>
                        <th class="t_center w_100">{{ $t('actions') }}</th>
                    </tr>
                </thead>
                <PmlForm :supplier="record" @updated="updateRecord" v-if="isAdding" @close="close"></PmlForm>
                <PmlItem v-for="item in list" :key="item.id" :item="item" :supplier="record" @updated="updateRecord"></PmlItem>
                <tbody>
                    <tr v-show="!list.length">
                        <td class="t_center" colspan="7"><i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import PmlForm from './Form.vue'
    import PmlItem from './Item.vue'
    import TableFilters from 'utils/mixins/table-filters'
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { mapGetters, mapActions } from 'vuex'
    import { getProducts } from 'services/suppliers'
    import { isEmpty } from 'lodash'

    export default {
        name: 'SupplierProducts',
        components: { PmlForm, PmlItem },
        mixins: [ TableFilters ],
        data () {
            return {
                isLoading: false,
                isAdding: false,
                record: {},
                listConfig: {
                    orderProp: 'product_name',
                    columns: ['product_name', 'unit']
                }
            }
        },
        mounted () {
            this.fetchRecord()
        },
        watch: {
            '$route' () {
                this.fetchRecord()
            }
        },
        computed: {
            ...mapGetters({
                units: 'getProductUnits'
            }),
            records () {
                return this.record.products || []
            }
        },
        methods: {
            ...mapActions([ 'supplierProductsAmountUpdate' ]),
            formatHtml (value) {
                return isEmpty(value) ? '' : this.$options.filters.pmlNl2br(value)
            },
            fetchRecord () {
                this.isLoading = true

                getProducts(this.$route.params.id)
                    .then(response => { this.record = response.data })
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => { this.isLoading = false })
            },
            updateRecord (supplier) {
                this.record = supplier
                this.supplierProductsAmountUpdate(this.record)
            },
            close () {
                this.isAdding = false
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/parameters/suppliers/components/products/Main.vue